import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import FileUpload from "react-drag-n-drop-image";
import ImageUploadField from "./ImageUploadField";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { DatePicker } from "antd";
import moment from "moment";

const CustomBody = () => {
  return (
    <div
      className="drag-file-area mt-0"
      style={{
        border: "0px",
        borderRadius: "0px",
        width: "100%",
        position: "relative",
      }}
    >
      <div>
        <CloudDownloadIcon style={{ fontSize: "50px" }} />
      </div>
      <h3 className="dynamic-message" style={{ fontFamily: "Montserrat" }}>
        Drag &amp; drop any file here
      </h3>
      <label className="">
        <span className="">
          <span
            className="browse-files-text"
            style={{
              fontFamily: "Montserrat",
              color: "#539ffe",
            }}
          >
            browse file
          </span>
          <span style={{ fontFamily: "Montserrat" }}>from device</span>
        </span>
      </label>
    </div>
  );
};

function ShowData({ files, onRemoveImage }) {
  return (
    <div className="">
      {files.map((item) => {
        return (
          <>
            <div
              className="drag-file-area mt-0"
              style={{
                border: "0px",
                borderRadius: "0px",
                position: "relative",
              }}
            >
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <div style={{ height: "200px", width: "200px" }} className="">
                  <img
                    src={item.preview}
                    alt="preview..."
                    height="100%"
                    width="100%"
                    style={{ objectFit: "contain" }}
                  />
                </div>
                <CloseIcon
                  style={{
                    cursor: "pointer",
                    color: "red",
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  // onClick={() => {
                  //   setDragImage2(true);
                  //   setImage2(null);
                  // }}
                  onClick={() => onRemoveImage(item.id)}
                />
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}

export default function Task() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [imageFile, setImageFile] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [files, setFiles] = React.useState([]);
  const [showImages, setShowData] = React.useState(false);
  const [isEditDataImage1, setIsEditDataImage1] = React.useState(false);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState(0);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const LoginSchema = Yup.object().shape({
    type: Yup.string().required("Required"),
    title: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    info: Yup.array()
      .of(
        Yup.object().shape({
          title: Yup.string().required("Required"),
          description: Yup.string().required("Required"),
        })
      )
      .min(1, "At least one info is required"),
    tab_name: Yup.string().required("Required"),
    rewards: Yup.array()
      .of(
        Yup.object().shape({
          type: Yup.number().required("Required"),
          title: Yup.string().required("Required"),
          seconds: Yup.number().required("Required"),
          web_count: Yup.number().required("Required"),
          click_data: Yup.string().required("Required"),
        })
      )
      .min(1, "At least one reward is required"),
    coin: Yup.number().required("Required"),
    status: Yup.string().required("Required"),
    start_date: Yup.string().required("Required"),
    end_date: Yup.string().required("Required"),
  });

  React.useEffect(() => {
    getBranch();
  }, [search, pageNumber, recordLength]);

  React.useEffect(() => {
    if (!rowValue) {
      setFiles([]);
      setImageFile([]);
    }
  }, [showPage]);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/tasks/get-tasks?search=${search}&page=${pageNumber}&limit=${recordLength}`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        if (response.data?.data?.tasks) {
          setTableData(response.data.data.tasks);
          setTotalLength(response.data.data.pagination.totalDocs);
        } else {
          setTableData(response.data.data || []);
          setTotalLength(response.data.pagination?.totalDocs || response.data.data?.length || 0);
        }
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
        setLoader(false);
      });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setRowValue(item);
    setOpenValue(2);
    setFiles([{ preview: item?.image_url }]);
    setImageFile(item?.image_url);
    setShowData(true);
  };

  const openAddTournament = (value) => {
    setRowValue();
    setShowPage(true);
    setOpenValue(value);
    setImageFile([]);
  };

  const IsEditOnRemoveImage = () => {
    setShowData(false);
    setFiles([]);
    setIsEditDataImage1(false);
  };

  const onRemoveImage = (id) => {
    setShowData(false);
    setFiles((prev) => prev.filter((i) => i.id !== id));
  };

  const onError = (error) => {
    console.error(error);
  };

  const onChange = (e) => {
    if (files.length === 0) {
      setShowData(true);
      setImageFile(e[0].file);
      setFiles(e);
    }
  };

  const updateTournament = (value) => {
    setbuttonLoader(true);
    const data = {
      type: value.type,
      title: value.title,
      description: value.description,
      info: value.info,
      seconds: value.seconds,
      tab_name: value.tab_name,
      coin: value.coin,
      status: value.status,
      start_date: value.start_date
        ? moment(value.start_date).format("DD-MM-YYYY")
        : "",
      end_date: value.end_date
        ? moment(value.end_date).format("DD-MM-YYYY")
        : "",
    };
    // Create FormData
    const formData = new FormData();

    // Append all basic fields from `data`
    Object.entries(data).forEach(([key, val]) => {
      if (typeof val === "object" && val !== null) {
        formData.append(key, JSON.stringify(val));
      } else {
        formData.append(key, val);
      }
    });

    // Append image file if available
    if (imageFile) {
      formData.append("image", imageFile);
    }

    // === REWARD DIFF LOGIC ===
    const versionData = value.rewards || []; // use from form input
    const rowData = rowValue.rewards || []; // previous state or existing data

    // Get _ids from rowData
    const rowIds = rowData.map((r) => r._id);

    // 1. Remove rewards: in rowData but not in versionData
    const versionRemoveIds = rowData
      .filter((rowItem) => !versionData.find((vd) => vd._id === rowItem._id))
      .map((rowItem) => rowItem._id);

    if (versionRemoveIds.length > 0) {
      formData.append("rewards_remove", JSON.stringify(versionRemoveIds));
    }

    // 2. Add rewards: no _id or not found in rowData
    const versionAddData = versionData.filter(
      (vd) => !vd._id || !rowIds.includes(vd._id)
    );

    if (versionAddData.length > 0) {
      formData.append("rewards_add", JSON.stringify(versionAddData));
    }

    // 3. Update rewards: _id exists in both
    const versionUpdateData = versionData.filter(
      (vd) => vd._id && rowIds.includes(vd._id)
    );

    if (versionUpdateData.length > 0) {
      formData.append("rewards_update", JSON.stringify(versionUpdateData));
    }

    axios(`${API_URL}/api/admin/tasks/update-tasks/${rowValue._id}`, {
      method: "PATCH",
      data: formData,
      credentials: "include",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((result) => {
        if (result.data.status) {
          console.log("result...", result);
          setbuttonLoader(false);
          successAdd(result.data.message);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
        setFiles([]);
        setImageFile([]);
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("updateTournament err :::", err);
        warningAlert();
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament ---", value);
    setbuttonLoader(true);
    const data = {
      type: value.type,
      title: value.title,
      description: value.description,
      info: value.info,
      seconds: value.seconds,
      tab_name: value.tab_name,
      rewards: value.rewards,
      coin: value.coin,
      status: value.status,
      start_date: value.start_date
        ? moment(value.start_date).format("DD-MM-YYYY")
        : "",
      end_date: value.end_date
        ? moment(value.end_date).format("DD-MM-YYYY")
        : "",
    };

    const formData = new FormData();
    // Append all body fields to formData
    Object.entries(data).forEach(([key, val]) => {
      if (typeof val === "object") {
        formData.append(key, JSON.stringify(val));
      } else {
        formData.append(key, val);
      }
    });
    formData.append("image", imageFile);

    axios(`${API_URL}/api/admin/tasks/add-tasks`, {
      method: "POST",
      data: formData,
      credentials: "include",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((result) => {
        console.log("tasks/add-tasks result...", result);

        if (result.data.status) {
          setbuttonLoader(false);
          successAdd(result.data.message);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
        setFiles([]);
        setImageFile([]);
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        warningAlert();
        setbuttonLoader(false);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
        title=""
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this task record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        title="Success"
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert"
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The task record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    axios
      .delete(`${API_URL}/api/admin/tasks/delete-tasks/${e._id}`)
      .then((res) => {
        successDeleted();
      });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The task record has been added successfully.</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  const tooltipProps = {
    tooltip: {
      sx: {
        bgcolor: '#2d3748',
        color: '#fff',
        fontSize: '13px',
        padding: '8px 12px',
        boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
        borderRadius: '6px'
      }
    },
    arrow: {
      sx: {
        color: '#2d3748'
      }
    }
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  type: rowValue ? rowValue.type : "",
                  title: rowValue ? rowValue.title : "",
                  description: rowValue ? rowValue.description : "",
                  info: rowValue ? rowValue.info : [],

                  seconds: rowValue ? rowValue.seconds : "",
                  tab_name: rowValue ? rowValue.tab_name : "",
                  rewards: rowValue ? rowValue.rewards : [],
                  coin: rowValue ? rowValue.coin : "",
                  status: rowValue ? rowValue.status : "",
                  start_date: rowValue?.start_date
                    ? new Date(rowValue.start_date).toISOString().slice(0, 10)
                    : "",
                  end_date: rowValue?.end_date
                    ? new Date(rowValue.end_date).toISOString().slice(0, 10)
                    : "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  // setbuttonLoader(true);
                  console.log("values...", values);

                  if (openValue === 1) {
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    updateTournament(values);
                  }
                }}
              >
                {({ values, touched, errors, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      {/* Basic Details */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Task Type <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="type"
                            className={`mt-1 form-control ${touched.type && errors.type ? "is-invalid" : ""}`}
                          >
                            <option value="">Select Type</option>
                            <option value={0}>Web</option>
                            <option value={1}>Android</option>
                            <option value={2}>IOS</option>
                          </Field>
                          <ErrorMessage component="div" name="type" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Tab Name <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="tab_name"
                            placeholder="e.g. Daily Tasks"
                            className={`mt-1 form-control ${touched.tab_name && errors.tab_name ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="tab_name" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Title <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="title"
                            placeholder="Task Title"
                            className={`mt-1 form-control ${touched.title && errors.title ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="title" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Description <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="description"
                            placeholder="Task Description"
                            className={`mt-1 form-control ${touched.description && errors.description ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="description" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Coins <span className="text-danger">*</span></label>
                          <Field
                            name="coin"
                            type="number"
                            placeholder="Reward Coins"
                            className={`mt-1 form-control ${touched.coin && errors.coin ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="coin" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Status <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="status"
                            className={`mt-1 form-control ${touched.status && errors.status ? "is-invalid" : ""}`}
                          >
                            <option value="">Select Status</option>
                            <option value={0}>Active</option>
                            <option value={1}>Inactive</option>
                          </Field>
                          <ErrorMessage component="div" name="status" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Start Date <span className="text-danger">*</span></label>
                          <Field
                            type="date"
                            name="start_date"
                            className={`mt-1 form-control ${touched.start_date && errors.start_date ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="start_date" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>End Date <span className="text-danger">*</span></label>
                          <Field
                            type="date"
                            name="end_date"
                            className={`mt-1 form-control ${touched.end_date && errors.end_date ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="end_date" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    {/* Info Section */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Task Info</h5>
                      <FieldArray
                        name="info"
                        render={(arrayHelpers) => (
                          <button
                            className="btn btn-outline-primary btn-sm"
                            type="button"
                            onClick={() => arrayHelpers.unshift({ title: "", description: "" })}
                          >
                            <AddIcon fontSize="small" className="mr-1" /> Add Info
                          </button>
                        )}
                      />
                    </div>

                    <FieldArray
                      name="info"
                      render={(arrayHelpers) => (
                        <div className="row">
                          {values.info.map((_, index) => (
                            <div key={index} className="col-md-6 mb-3">
                              <div className="card mb-3 h-100" style={{ borderRadius: '10px' }}>
                                <div className="card-body p-3">
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="badge badge-secondary">Info #{values.info.length - index}</span>
                                    <button
                                      className="btn btn-link text-danger p-0"
                                      type="button"
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <ClearIcon fontSize="small" />
                                    </button>
                                  </div>
                                  <div className="form-group mb-2">
                                    <Field
                                      name={`info[${index}].title`}
                                      className="form-control form-control-sm"
                                      placeholder="Title"
                                    />
                                  </div>
                                  <div className="form-group mb-0">
                                    <Field
                                      name={`info[${index}].description`}
                                      className="form-control form-control-sm"
                                      placeholder="Description"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    />

                    <hr className="my-4" />

                    {/* Rewards Section */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Rewards Configuration</h5>
                      <FieldArray
                        name="rewards"
                        render={(arrayHelpers) => (
                          <button
                            className="btn btn-outline-primary btn-sm"
                            type="button"
                            onClick={() => arrayHelpers.unshift({ title: "", seconds: "", web_count: "", click_data: "" })}
                          >
                            <AddIcon fontSize="small" className="mr-1" /> Add Reward
                          </button>
                        )}
                      />
                    </div>

                    <FieldArray
                      name="rewards"
                      render={(arrayHelpers) => (
                        <div className="row">
                          {values.rewards.map((_, index) => (
                            <div key={index} className="col-md-6 mb-4">
                              <div className="card mb-3 h-100" style={{ borderRadius: '10px' }}>
                                <div className="card-body p-3">
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <span className="badge badge-primary">Reward #{values.rewards.length - index}</span>
                                    <button
                                      className="btn btn-link text-danger p-0"
                                      type="button"
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <ClearIcon fontSize="small" />
                                    </button>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="form-group mb-2">
                                        <label className="small">
                                          Title{" "}
                                          <Tooltip title='The display name of the reward. (Ex. "Visit our sponsor")' placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                                            <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                                          </Tooltip>
                                        </label>
                                        <Field
                                          name={`rewards[${index}].title`}
                                          className="form-control form-control-sm"
                                          placeholder="Reward Title"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="form-group mb-2">
                                        <label className="small">
                                          Seconds{" "}
                                          <Tooltip title="The time (in seconds) the user must wait or watch the content before the reward is unlocked." placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                                            <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                                          </Tooltip>
                                        </label>
                                        <Field
                                          name={`rewards[${index}].seconds`}
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="Seconds"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group mb-2">
                                        <label className="small">
                                          Web Count{" "}
                                          <Tooltip title="Minimum webview interaction count required before website task time calculation starts. Task duration tracking begins only after the configured interaction limit is reached." placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                                            <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                                          </Tooltip>
                                        </label>
                                        <Field
                                          name={`rewards[${index}].web_count`}
                                          type="number"
                                          className="form-control form-control-sm"
                                          placeholder="Count"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="form-group mb-0">
                                    <label className="small">
                                      Click URL{" "}
                                      <Tooltip title="URL used for task redirection. Example: https://example.com" placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                                        <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                                      </Tooltip>
                                    </label>
                                    <Field
                                      name={`rewards[${index}].click_data`}
                                      className="form-control form-control-sm"
                                      placeholder="https://..."
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    />

                    <hr className="my-4" />

                    {/* Image Section */}
                    <div className="form-group">
                      <label className="mb-2">Task Banner Image</label>
                      <div className="file-upload-box">
                        {showImages ? (
                          <ShowData files={files} onRemoveImage={onRemoveImage} />
                        ) : (
                          <FileUpload
                            onError={onError}
                            body={<CustomBody />}
                            overlap={false}
                            fileValue={files}
                            onChange={(e) => onChange(e)}
                          />
                        )}
                      </div>
                    </div>

                    <div className="d-flex mt-4 pt-4 border-top">
                      <button
                        style={{ width: "110px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            {/* <div
              class="pl-4 pr-4 pt-4"
              style={{ display: "flex", justifyContent: "space-between" }}
                          > */}
            <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-end">
                <div className="col-md-4 mb-3 mb-md-0">
                  <label className="small text-muted font-weight-bold mb-1">Search Task</label>
                  <div className="position-relative">
                    <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                    <input
                      className="form-control premium-search-input"
                      type="text"
                      placeholder="Search..."
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setPageNumber(1);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-8 text-right">
                  {accessObject?.editGameHandle === true && (
                    <button
                      onClick={() => {
                        openAddTournament(1);
                      }}
                      type="button"
                      className="btn btn-primary"
                    >
                      <AddIcon /> Add New
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Sr.no</th>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Coin</th>
                    <th>Type</th>
                    {(accessObject?.editGameHandle === true ||
                      accessObject?.deleteGameHandle === true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {!loader ? (
                    <>
                      {tableData.length > 0 ? (
                        <>
                          {tableData
                            .map((item, index) => (
                              <>
                                <tr key={index}>
                                  <td>{index + 1 + (pageNumber - 1) * recordLength}</td>
                                  <td>
                                    {moment(item.createdAt)?.format(
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>{item.title}</td>
                                  <td>{item.coin}</td>
                                  <td>
                                    {item.type === 0 && "Web"}
                                    {item.type === 1 && "Android"}
                                    {item.type === 2 && "IOS"}
                                  </td>
                                  {(accessObject?.editGameHandle === true ||
                                    accessObject?.deleteGameHandle ===
                                    true) && (
                                      <td className="justify-content-evenly ">
                                        <div className="d-flex">
                                          {accessObject?.editGameHandle ===
                                            true && (
                                              <EditIcon
                                                className="mr-3 courser"
                                                onClick={() =>
                                                  clickEditButton(item)
                                                }
                                              />
                                            )}
                                          {accessObject?.deleteGameHandle ===
                                            true && (
                                              <ClearIcon
                                                className="courser text-danger"
                                                onClick={() =>
                                                  warningWithConfirmMessage(item)
                                                }
                                              />
                                            )}
                                        </div>
                                      </td>
                                    )}
                                </tr>
                              </>
                            ))}
                        </>
                      ) : (
                        <EmptyState colSpan={8} />
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
              <div className="mt-4">{loader && <Loader />}</div>
            </div>
            {tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
                paginationTypeApi={true}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                recordLength={recordLength}
                setRecordLength={setRecordLength}
                totalLength={totalLength}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
